import {IShow3dVisualizer, IVisualizerManager} from "./VisualizerContext";
import {HttpTransportType, HubConnection} from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import {IShow3DOptions} from "../components/visualizer/VisualizerSessionManager";
import {IActorTrigger} from "../unreal/BigScreenWebPage";
import {IOptionSetRequest} from "../unreal_api/UnrealClient";
import {IMessageSender} from "./UnrealSignalRVisualizer";
import IVscCommunityMapInfo from "./IVscCommunityMapInfo";
import {IViewpoint} from "../data/IViewpoint";


function shortenActorTrigger(trigger:IActorTrigger) {
    let rval = `${trigger.C}/${trigger.T}/${trigger.F}`
    if (trigger.P !== undefined && trigger.P.length > 0) {
        rval += `/${trigger.P.join("|")}`;
    }
    return rval;
}


function shortenActorTriggers(trigger:IActorTrigger[]) {
    return trigger.map(t => shortenActorTrigger(t)).join("!");
}
export class VscUnrealSignalRVisualizerManager implements IVisualizerManager, IShow3dVisualizer, IMessageSender {

    private connection: HubConnection|undefined;
    private readonly recipient:string;

    getMessageSender(): IMessageSender {
        return this;
    }

    constructor(private readonly serverUri: string, private readonly salesCenterId:string, private readonly stationId:string, private readonly token:string) {
        this.recipient = `${salesCenterId} ${stationId}`;

    }
    private connectionPromise: Promise<void>|undefined;

    connect() {
        if (this.connectionPromise !== undefined) {
            return this.connectionPromise;
        }
        const uri = `${this.serverUri}-/hub`;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(uri, { transport: HttpTransportType.LongPolling })
            .withAutomaticReconnect()
            .build();
        this.connectionPromise = this.connection.start();
        const w = window as any;
        if (w) {
            w.signalRConnection = this.connection;
        }

        return this.connectionPromise;

    }


    async verifyConnection(): Promise<string | null> {

        return null;
    }

    changeCamera(cameraId: string) {
        if (this.connection === undefined) throw "Not connected!";
        //const body = "value=" + encodeURIComponent(cameraId).replace(/%20/g, "+");
        this.connection.send("unrealMessage", {
            type: "ChangeCamera",
            recipient: this.recipient,
            content: cameraId
        });
    }

    changeCameraToViewpoint(viewpoint: IViewpoint, relativeTo?: string) {
        if (this.connection === undefined) throw "Not connected!";

        this.connection.send("unrealMessage", {
            type: "ChangeCameraViewpoint",
            recipient: this.recipient,
            content: JSON.stringify({ RelativeTo: relativeTo, ...viewpoint})
        })
    }

    sendMessage(msg: unknown) {
        if (this.connection === undefined) throw "Not connected!";
        this.connection.send("unrealMessage", {
            recipient: this.recipient,
            type: "MediaCanvas",
            content: JSON.stringify(msg)
        })
    }

    async browse(stateIndex: string, uri: string) {
        const parsedUrl = new URL(uri);
        const authDomain = parsedUrl.origin;

        console.log('browsing to ' + uri);
        await this.sendMessage({Id: stateIndex, Command: "Browse", Url: uri, Auth: this.token, AuthDomain: authDomain});

    }

    async show3d(sessionId: string, options: IShow3DOptions) {
        const msg = {
            Id: sessionId,
            Command: "ThreeDC",
            Mode: options.mode,
            Map: options.map,
            ActorTriggers: shortenActorTriggers([])
        }
        await this.sendMessage(msg);
        return true;
    }


    async playVideo(sessionId:string, file: string, looping: boolean) {


        const msg = {
            Id: sessionId,
            Command: "VideoPlay",
            Video: (file.startsWith("http://") || file.startsWith("https://")) ? file : ("./Movies/" + file)
        } as any;

        if (looping) {
            msg.Loop = true;
        }
        await this.sendMessage(msg);
    }

    sendOptions(req: IOptionSetRequest): void {
        if (this.connection === undefined) throw "Not connected!";
        let options: string[] = [];
        for (const option of Object.keys(req.options)) {
            options.push(req.options[option].OptionSelection);
        }
        this.connection.send("unrealMessage", {
            type: "Options",
            recipient: this.recipient,

            content: JSON.stringify({lot: req.lot, options: options})
        });
    }

    async requestMapInfo(): Promise<IVscCommunityMapInfo> {
        const mapInfoResult = await fetch(this.serverUri + "mapInfo/requestMapInfo", { method: "GET"});

        if (!mapInfoResult.ok) {
            throw "Invalid map response";
        }
        
        const mapInfoJson = await mapInfoResult.json();
        return mapInfoJson as IVscCommunityMapInfo;

        /*if (this.connection === undefined) throw "Not connected!";


        this.connection.send("unrealMessage", {
            type: "MapInfo",
            recipient: this.recipient,
            content: ""
        });
        return Promise.reject();*/
    }
}
